// FAQ ------------------------------------------- //
$('.faq__section').each(function() {
  var $section = $(this);
  var $question = $(this).find('.faq__question');
  var $answer = $(this).find('.faq__answer');

  $question.click(function() {
    $answer.slideToggle('fast');
    $section.toggleClass('open');
  });
});
